export const APP_CONFIG = {
  1: {
    storeId: 218976,
    appid: 'wx768a2a9f6d694cda',
    name: '英歌魂',
  },
  2: {
    storeId: 216652,
    appid: 'wx3423ef0c7b7f19af',
    name: '爷爷不泡茶',
  },
  3: {
    storeId: 205169,
    appid: 'wx0a3c666ac4f68451',
    name: '百分茶喵',
  },
  4: {
    storeId: 216350,
    appid: 'wx8b66c3abfe6f646b',
    name: '酸奶罐罐',
  },
  5: {
    storeId: 217777,
    appid: 'wx17102e91e70c9b9b',
    name: '茉莉奶白',
  },
  6: {
    storeId: 33750,
    appid: 'wx36074f6ae49fe9d1',
    name: '一只酸奶牛',
  },
  7: {
    storeId: 203192,
    appid: 'wxf4b12e079bb99abc',
    name: '阿水',
  },
  8: {
    storeId: 49006,
    appid: 'wxafec6f8422cb357b',
    name: '霸王',
  },
  10: {
    storeId: 203009,
    appid: 'wx4080846d0cec2fd5',
    name: '益和堂',
  },
  12: {
    storeId: 214977,
    appid: 'wxd5c753ccda23bf90',
    name: '茶救星球',
  },
};

// 默认导出一个获取配置的函数，方便使用
// 您可以根据实际需求（比如从URL参数、本地存储等）来决定使用哪种配置
export const getConfig = (type = 1) => {
  return APP_CONFIG[type] || APP_CONFIG[1]; // 如果找不到指定类型，则返回默认配置
}; 